import React, { useCallback } from 'react';
import {
  FormattedRichMessage,
  CoBrandingButton,
  ContentPage,
  customStyles,
  useRichIntl,
  useCIAMHistory,
  useCIAMContextParam,
  useRealm,
} from 'ciam-self-service-shared';
import Page, { AUTH_TYPE } from 'components/common/Page';
import FormElement from 'components/common/FormElement';
import { FormattedMessage } from 'react-intl';
import { BUTTON_VARIANT } from '@manulife/mux';
import useRedirectOnStageReset from '../../hooks/useRedirectOnStageReset';
import useResetStageOnHistoryChange from '../../hooks/useResetStageOnHistoryChange';
import { useDispatch, useSelector } from 'react-redux';
import { forcePasswordResetAsyncAction } from 'utils/loginAuthnTree/signinAsyncActionImpl';
import { D704_ERROR } from 'components/ForgotPassword/constants';

const ForcePasswordPage = () => {
  const intl = useRichIntl();
  const dispatch = useDispatch();
  const stage = useSelector((state) => state.loginInfo.stage);
  const history = useCIAMHistory();
  const brand = useCIAMContextParam('brand');
  const { locale } = intl;
  const realm = useRealm();
  const onContinue = useCallback(async () => {
    await forcePasswordResetAsyncAction(dispatch, stage, history, locale, realm, brand);
  }, [brand, dispatch, history, locale, realm, stage]);

  // Handle page refresh - redirect to Sign-In page with G_200 error
  useResetStageOnHistoryChange();
  useRedirectOnStageReset(D704_ERROR, '/', false);

  return (
    <Page
      title={intl.formatMessage({ id: 'forcePassword.page.title' })}
      authType={AUTH_TYPE.UNAUTHENTICATED}
      heading={intl.formatMessage({ id: 'forcePassword.page.heading' })}
    >
      <ContentPage heading={<FormattedRichMessage id="forcePassword.page.heading" />}>
        <FormattedRichMessage id="forcePassword.page.content" />
        <FormElement spacing={2}>
          <CoBrandingButton
            variant={BUTTON_VARIANT.PRIMARY}
            customStyle={customStyles.button}
            onClick={onContinue}
            id="force-password-continue-btn"
          >
            <FormattedMessage id="common.continue" />
          </CoBrandingButton>
        </FormElement>
      </ContentPage>
    </Page>
  );
};

export default ForcePasswordPage;
